import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    borderRadius: theme.radius.md,
    backgroundColor: theme.palette.facet.accentBlue20,
    padding: theme.spacing(2.5),
  },
  title: {
    paddingBottom: theme.spacing(2.5),
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightExtraBold,
  },
  item: {
    paddingBottom: theme.spacing(0.5),
  },
  itemContent: {
    color: theme.palette.facet.primaryGray,
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
  },
  unorderedList: {
    paddingLeft: theme.spacing(2),
    marginBottom: 0,
  },
});

const CardItemList = ({
  className,
  classes,
  title,
  textArray,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {title ? (
        <Typography
          className={classes.title}
          weight="bold"
          color="primary"
          align="center"
        >
          {title}
        </Typography>
      ) : null}
      <ul className={classes.unorderedList}>
        {
          textArray.map(item => (
            <li key={item} className={classes.item}>
              <Typography className={classes.itemContent}>{item}</Typography>
            </li>
          ))}
      </ul>
    </Box>
  );
};

CardItemList.defaultProps = {
  className: '',
  title: '',
  textArray: [],
};

CardItemList.propTypes = {
  title: PropTypes.string,
  textArray: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardItemList);
